import IndustryPageTemplate from "./IndustryPageTemplate";
import { cleaningServicesData } from "@/data/cleaningServices";

export default function CleaningServicesPage() {
  return <IndustryPageTemplate data={cleaningServicesData} />;
}
